import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { UserManagementPage } from "src/components/views/users/management/UserManagementPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/users/management")({
	staticData: { title: i18n.t("users"), legacyViewKey: "userManagementPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <UserManagementPage />;
}
